import { render, staticRenderFns } from "./the-dashboard-navigation.vue?vue&type=template&id=be92db54"
import script from "./the-dashboard-navigation.vue?vue&type=script&lang=js"
export * from "./the-dashboard-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports